import React, { useContext, useEffect,useState } from 'react'
import { useLocation } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { Box } from '@material-ui/core'
import ModalMui from '../core/ModalMui'

import Loading from "../core/Loading";
import AuthContext from '../../context/authentication/authContext'
import PortalContext from '../../context/portal/portalContext'
import ModalContext from '../../context/modal/modalContext'
import BillContext from '../../context/bill/BillContext'
import ReceiverContext from '../../context/receiver/ReceiverContext'

import useMediaQuery from '../../hooks/useMediaQuery'

import BillsTables from './BillsTables'
import NewBillDetails from './NewBillDetails'
import './bills.css'

import { Cancel, Save } from '@material-ui/icons'
import NewBillReferences from './NewBillReferences'
import { success } from 'concurrently/src/defaults'

const formatRut = (rut)=>{
   // XX.XXX.XXX-X
   const newRut = rut.replace(/\./g,'').replace(/\-/g, '').trim().toLowerCase();
   const lastDigit = newRut.substr(-1, 1);
   const rutDigit = newRut.substr(0, newRut.length-1)
   let format = '';
   for (let i = rutDigit.length; i > 0; i--) {
     const e = rutDigit.charAt(i-1);
     format = e.concat(format);
     if (i % 3 === 0){
       format = '.'.concat(format);
     }
   }
   return format.concat('-').concat(lastDigit);
 }

 	 function formatCurrency(value) {
    const formatter = new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return formatter.format(value);
  }
  

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        height: '100%',
      },
      componentTitle: {
        fontSize: '24px',
        color: '#263AE3',
        marginBottom: 15,
      },
      title:{
          fontFamily:'Roboto',
          fontStyle:'normal',
          fontWeight:'400',
          fontSize:'32px',
          lineHeight:'20px',
          color:'#001070',
          marginBottom:'46px'
        },
        newBill:{
            backgroundColor:'white',
            borderRadius:'10px',
            display:'flex',
            flexDirection:'column',
            padding: '30px'
        },
        newBillBlock:{
            display:'flex',
            marginBottom:'50px',
            justifyContent:'space-between',       
    
        },
        newBillBlockReference:{
            display:'flex',
            flexDirection:'column',
            marginBottom:'50px',
            justifyContent:'space-between',       
    
        },
        newBillBlockGuideReference:{
            display:'flex',      
            flexDirection:'column',
            marginTop:'50px',     
    
        },
        newBillBlockButtons:{
            display:'flex',
            flexDirection:'row', 
    
        },
        newBillBlockItem:{
            display:'flex',
            flexDirection:'column',
            paddingRight: '22px'
           
        },
        fiscalNumber:{
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "32px",
            lineHeight: "20px",
            textTransform: "capitalize",
            color: "#DA291D",
            textAlign:'center',
            marginBottom:'40px'
        },
        fiscalDocument:{
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: "16px",
            lineHeight: "20px",
            textTransform: "uppercase",
            color: "#DA291D",
            textAlign:'center',
            marginBottom:'40px'
        },
        newBillFieldContainer:{
            display:'flex',
            flexDirection:'row',
            justifyContent:'space-between',
            alignItems:'center',
            margin: '2px'
        },
        newBillFieldGuideContainer:{
            display:'flex',
            flexDirection:'row',
            justifyContent:'space-between',
            alignItems:'center',
            margin: '2px'
        },
        newBillFieldDateContainer:{
            display:'flex',
            flexDirection:'row',
            justifyContent:'center',
            alignItems:'center',
            margin: '2px',
            paddingTop:'10px'
        },
        newBillFieldInput:{
            border:'1px rgba(232, 233, 234, 1) solid',
            width:'368px',
            height:'38px',
            borderRadius:'6px',
            padding:'10px',
            fontSize: '16px',
            lineHeight: '22px',
            color:' #949CA9',

            
        },
        newBillFieldData:{
            border:'1px rgba(232, 233, 234, 1) solid',
            width:'368px',
            height:'38px',
            borderRadius:'6px',
            padding:'10px',
            fontSize: '16px',
            lineHeight: '22px',
            color:' #949CA9',
            backgroundColor:'#f7f7f7' 
            
        },
        newBillFieldTotalData:{
            border:'1px rgba(232, 233, 234, 1) solid',
            width:'368px',
            height:'38px',
            borderRadius:'6px',
            padding:'10px',
            fontSize: '16px',
            lineHeight: '22px',
            color:' #949CA9',
            textAlign:'right',
            backgroundColor:'#f7f7f7' 
            
        },

        newBillFieldSelectInput:{
            border:'1px rgba(232, 233, 234, 1) solid',
            width:'200px',
            height:'38px',
            borderRadius:'6px',
            padding:'10px',
            fontSize: '16px',
            lineHeight: '22px',
            color:' #949CA9',
        },

        newBillFieldDateInput:{
            border:'1px rgba(232, 233, 234, 1) solid',
            width:'200px',
            height:'38px',
            borderRadius:'6px',
            padding:'10px',
            fontSize: '16px',
            lineHeight: '22px',
            color:' #949CA9',
            textAlign:'center'

            
        },
        newBillFieldLabel:{
            fontFamily:'inter',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '20px',
            lineHeight: '20px',
            transform: 'Capitalize',
            color: '#000000',
            marginRight:'20px',  
        },

        newBillFieldGuideLabel:{
            fontFamily:'inter',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '20px',
            lineHeight: '20px',
            transform: 'Capitalize',
            color: '#000000',
            marginRight:'20px',  
        },


        newBillFieldSectionLabel:{
            fontFamily:'inter',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '24px',
            lineHeight: '20px',
            transform: 'Capitalize',
            color: '#001070',
            marginBottom:'13px'
        },
        newBillSearchButton:{
            padding:'10px 20px',
            background: 'rgba(218, 41, 29, 0.86)',
            borderRadius:'6px',
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '20px',
            textAlign:"center",
            color:'#ffffff',
            cursor:'pointer'
        },
    }))

const NewBill = (props) => {
  const location = useLocation()
  const authContext = useContext(AuthContext)
  const { authenticatedUser } = authContext

  const modalContext=useContext(ModalContext)
  const { modalShow, showModal, closeModal } = modalContext
  const [modalContent, setModalContent] = useState(null)
  const [modalTitle, setModalTitle] = useState('')
  const { customerId,shopId,postBill,billData,completed, error,clear,errorMsg } = useContext(BillContext)
  const [ selectableReceivers , setSelectableReceivers ] = useState()
  const { getReceiver, receivers, history } = useContext(ReceiverContext)
  const [ billDate , setBillDate ] = useState(new Date().toLocaleDateString() )
  const [ currentBill, setCurrentBill ] = useState({})
  const [ totals, setTotals ] = useState({})
  const [ isReferred, setIsReferred ] = useState()
  const [ viewData, setViewData ] = useState({})
  const [ isWaiting, setIsWaiting ] = useState(false)

  const classes = useStyles()
  const isMobile = useMediaQuery('max-width', 600)


  function setBillType(event){
   // //console.log(event.currentTarget.value)
    const current = {...currentBill }
    current.Type=parseInt(event.currentTarget.value)
    setCurrentBill(current)
  }

  function search(event){
    const s = document.getElementById('searchField')

    if(s.value!=''){

     //   const w = event.currentTarget.offsetLeft
        getReceiver(currentBill.CustomerId,(currentBill.Type===45||currentBill.Type===46)?2:1,s.value,1,100)
        document.getElementById('selectableList').style.display='block'
    }else{
        setSelectableReceivers()
    }
  }

  function emit(){
    //console.log('emit')
    if(currentBill.ReferredDocument &&
      (!currentBill.ReferredDocument.ReasonIdForRef || currentBill.ReferredDocument.ReasonIdForRef<=0)){
             alert('Por favor seleccione la razón para emitir el documento')
             return
    }
    postBill(currentBill)
    setModalTitle('Generando documento, espere un momento por favor...')
    setModalContent()
    showModal()
  }

  const toPage = () => {
    history.push('/app/bills-list');
    window.scrollTo(0,0)
  }

  function addDetail(detail){
    const current = {...currentBill }
    current.Details.push(detail)
    setCurrentBill(current)
    //setTimeout(updateTotals,300)
  }

  function deleteDetail(index){
    const current = {...currentBill }
    delete current.Details[index]
    const detailsss = current.Details
    current.Details = []
    detailsss.forEach(d=>current.Details.push(d))
    setCurrentBill(current)
    setTimeout(updateTotals,300)
 }

 function clearSelectableReceiversList(){
    setSelectableReceivers()
 }

 function setGlosa(glosa){
    const newBill = { ...currentBill }
    if(newBill.ReferredDocument){
        newBill.ReferredDocument.CommentForRef = glosa
    }
    setCurrentBill(newBill)
 }
 function setReason(reasonId){
    const newBill = { ...currentBill }
    if(newBill.ReferredDocument){
        newBill.ReferredDocument.ReasonIdForRef = parseInt(reasonId)
    }
    setCurrentBill(newBill)
 }
 function updateTotals(details){
       if((currentBill && currentBill.Details)||details){
            let totalNeto = 0
            let totalExento= 0
            let totalIva= 0
            let totalRetencion= 0
            let totalTotal= 0
            if(!details)details= currentBill.Details
            details.map(e=>{
                if(e.VatToApply>0){
                    totalNeto+=e.total
                }else{
                    totalExento+=e.total
                }
            })
            totalIva = Math.round(totalNeto*0.19)// totalNeto-Math.round(totalNeto/1.19)
            totalTotal=totalNeto+totalExento+totalIva
            setTotals({
                totalNeto,
                totalExento,
                totalIva,
                totalRetencion,
                totalTotal
            })
       }
    }

  function setReceiver(receiver){
      setCurrentBill({
          ...currentBill,
          ReceiverId:receiver.id
      })
      setViewData( {
          ...viewData,
          ...receiver
      })
      document.getElementById('selectableList').style.display='none'
       const s = document.getElementById('searchField')
       if(s)s.value=''
  }

  function selectFiscalDocument(value){
      const fds = document.getElementById('fiscalDocSelect')
        if(fds){
            for(let m=0;m<fds.options.length;m++){
              if(fds.options[m].value===`${value}`) {
                  fds.selectedIndex=m
                  break
              }
            }
        }
  }

  function setShippingAddress(event){
        if(!currentBill.ShippingInformation)currentBill.ShippingInformation={}
        currentBill.ShippingInformation.ShippingAddress = event.currentTarget.value
  }
  function setShippingLocality(event){
            if(!currentBill.ShippingInformation)currentBill.ShippingInformation={}
            currentBill.ShippingInformation.ShippingLocality = event.currentTarget.value
      }
  function setAdditionalInformation(event){
          if(!currentBill.ShippingInformation)currentBill.ShippingInformation={}
          currentBill.ShippingInformation.AdditionalInformation = event.currentTarget.value
    }
  useEffect(() => {
      if(receivers){
          if(isReferred&&isReferred==='REFERRED'){
              document.getElementById('selectableList').style.display='none'
              const rec = receivers.filter(r=>r.id==currentBill.ReceiverId)
              if(rec&&rec.length>0){
                setReceiver(rec[0])
            }
          }
          else{
           setSelectableReceivers(receivers)
          }
      }
  }, [receivers])

  useEffect(() => {
        if(completed&&completed==='COMPLETED') {
            setModalTitle('Documento creado correctamente')

            setModalContent(
                <div style={{display:'flex',justifyContent:'center', width:'100%'}}>
                    <button onClick={()=>{ history.push('/app/bills-list')}}
                            style={{
                                padding: '10px 20px',
                                 background: 'rgb(0, 16, 112)',
                                 borderRadius: '6px',
                                 marginRight: '15px',
                                 fontSize: '14px',
                                 lineHeight: '20px',
                                 height:'40px',
                                 textAlign: 'center',
                                 color: 'rgb(255, 255, 255)',
                                 width:'180px',
                                 cursor: 'pointer'
                    }}>
                        Aceptar
                    </button>
                 </div>
            )
        }
  }, [completed])

  useEffect(() => {
      if(error&&error!=='') {
          setModalTitle(error)
          setModalContent(
              <div style={{display:'flex',justifyContent:'center', width:'100%'}}>
                  <button onClick={closeModal}
                          style={{
                              padding: '10px 20px',
                               background: 'rgb(0, 16, 112)',
                               borderRadius: '6px',
                               marginRight: '15px',
                               fontSize: '14px',
                               lineHeight: '20px',
                               height:'40px',
                               textAlign: 'center',
                               color: 'rgb(255, 255, 255)',
                               width:'180px',
                               cursor: 'pointer'
                  }}>
                      Aceptar
                  </button>
               </div>
          )
          clear()
      }
  }, [error])

  useEffect(() => {
       // //console.log('currentBill',currentBill)
        if(currentBill) {
            updateTotals()
        }
  }, [currentBill])

  useEffect(() => {
    if(isReferred&&isReferred==='REFERRED'){
        getReceiver(currentBill.CustomerId,1,'',1,10000)
    }
  },[isReferred])

  useEffect(() => {
    closeModal()
    if (localStorage.getItem('hasToChange') === 'true') {
      props.history.push('/app/change-password?show-terms-of-use=1')
    }
    authenticatedUser()
    clear()
   // //console.log('currentBill',currentBill)
    if(currentBill&&currentBill.Type){
        selectFiscalDocument(currentBill.Type)
    }
    const customers = JSON.parse(localStorage.getItem('customers'))
    const d = new Date()
    const ts = d.getFullYear()
               +'-'+(d.getMonth()+1).toString().padStart(2, '0')
               +'-'+d.getDate().toString().padStart(2, '0')
               +'T'+d.getHours().toString().padStart(2, '0')
               +':'+d.getMinutes().toString().padStart(2, '0')
               +':'+d.getSeconds().toString().padStart(2, '0')
    const newBill = {}
    setCurrentBill( {
        TimeStamp:ts,
        CustomerId: customers[0].id,
        ShopId: customers[0].shops[0].id,
        Type:33,
        Details:[]
     })
     setViewData( {
            CustomerFiscalKey: formatRut(customers[0].fiscalKey),
            currentDate: new Date().toLocaleDateString()
        })

     const rf = sessionStorage.getItem('referenceData')
     if(rf){
        setIsReferred('REFERRED')
        const referenceData = JSON.parse(rf)
        const newBill = {
            TimeStamp:ts,
            CustomerId: customers[0].id,
            ShopId: customers[0].shops[0].id,
            Type: referenceData.typesToRefer,
            ReceiverId:referenceData.ReceiverId ?? 0,
            Details:[]
        }
        referenceData.Details.map(m=>{
            const d = {
                ProductCode:m.productCode,
                ProductName:m.productName,
                Quantity:m.quantity,
                MeasureUnit:m.measureUnit,
                UnitPrice:m.unitPrice,
                DiscountPercentage:m.discountPercentage,
                VatToApply:m.vatToApply,
            }
            d.total = Math.round(d.Quantity*d.UnitPrice)
            if(d.discountPercentage>0){
                 d.total = Math.round(d.total-d.total*d.DiscountPercentage/100)
            }
            newBill.Details.push(d)
        })
        if(referenceData.typesToRefer!=referenceData.documentType){ //DUPLICADO
            newBill.ReferredDocument = {
                DocumentIdToReference : referenceData.documentId,
                ReasonIdForRef : referenceData.value
            }
        }
        setCurrentBill(newBill)
        setTimeout(selectFiscalDocument(referenceData.typesToRefer),500)
        updateTotals(newBill.Details)
      }
      setSelectableReceivers()
  }, [])

  if(isWaiting){
    return (<Loading/>)
  }else
  return (
    <div
      className={classes.root}
      style={{ padding: !isMobile ? '24px' : '0px' }}
    >
     {modalShow &&
                  <ModalMui
                    modalShow={modalShow}
                    showModal={showModal}
                    closeModal={closeModal}
                    modalTitle={modalTitle}

                  >
                    {modalContent}
                  </ModalMui>
                  }
        <div className={classes.title}>
            Nuevo Documento
        </div>
        <div className={classes.newBill}>
            <div className={classes.newBillBlock}>
                <div className={classes.newBillBlockItem}>
                <div className={classes.newBillFieldContainer}>
                    <label className={classes.newBillFieldLabel} htmlFor='searchFiscalInformation'>Búsqueda</label>
                    <input type='text'
                        id='searchField'
                        className={classes.newBillFieldInput}
                        placeholder='Ingrese Nombre o Rut'
                        onChange={search}
                    />
                    <div className="selectableList" id="selectableList">
                    {
                        selectableReceivers && //receivers.length && receivers.length>0 &&
                                selectableReceivers.map((n)=>{
                                return(
                                    <div className="selectableItem" key={n.id} onClick={()=>{setReceiver(n)}}>
                                        {n.fiscalKey} {n.fiscalName}
                                    </div>
                            ) })
                    }
                    </div>
                </div>
                    <div className={classes.newBillFieldContainer}>
                        <label className={classes.newBillFieldLabel} htmlFor='FiscalName'>Rut</label>
                    <div className={classes.newBillFieldData}>{viewData.fiscalKey}</div>
                </div>
                <div className={classes.newBillFieldContainer}>
                    <label className={classes.newBillFieldLabel} htmlFor='FiscalName'>Razón Social</label>
                    <div className={classes.newBillFieldData}>{viewData.fiscalName}</div>
                </div>
                <div className={classes.newBillFieldContainer} >
                        <label className={classes.newBillFieldLabel}  htmlFor='giro'>Giro</label>
                        <div className={classes.newBillFieldData}>
                            {viewData.category}
                        </div>
                </div>
                <div className={classes.newBillFieldContainer} >
                        <label className={classes.newBillFieldLabel} htmlFor='address'>Dirección</label>
                        <div className={classes.newBillFieldData} >
                            {viewData.address}
                        </div>
                </div>
                <div className={classes.newBillFieldContainer} >
                        <label className={classes.newBillFieldLabel} htmlFor='type'>Tipo de Movimiento</label>
                        <select type='text'
                                id='type'
                                className={classes.newBillFieldSelectInput}
                                defaultValue={0}>
                             <option value="0" disabled > Seleccione</option>
                            <option  value="1">DEL GIRO</option>
                            <option value="2">FUERA DE GIRO</option>
                        </select>
                </div>
                <div className={classes.newBillFieldContainer} disabled>
                        <label className={classes.newBillFieldLabel} htmlFor='contact'>Contacto</label>
                        <div  className={classes.newBillFieldData}>
                            {viewData.contact}
                        </div>
                </div>
            </div>
            <div className={classes.newBillBlockItem}>
            <div className="boxFiscalInformation">
                <div className="fiscalKey">
                    RUT {viewData.CustomerFiscalKey}
                </div>
                <div className={classes.newBillFieldContainer} >
                    <select className={classes.fiscalDocument} defaultValue={33} onChange={setBillType} id="fiscalDocSelect">
                        <option value={33} >FACTURA ELECTRONICA AFECTA</option>
                        <option value={34} >FACTURA EXENTA ELECTRONICA </option>
                        <option value={52} >GUIA DE DESPACHO</option>
                        <option value={61} >NOTA DE CREDITO</option>
                        <option value={56} >NOTA DE DEBITO</option>
                        <option value={46} >FACTURA DE COMPRA </option>
                    </select>
                </div>
                <div className={classes.fiscalNumber} >
                    N° no asignado
                </div>
                </div>
                <div className={classes.newBillFieldDateContainer}>
                    <label  className={classes.newBillFieldLabel} htmlFor='date'>Fecha</label>
                    <input type='text'
                           id='date'
                           className={classes.newBillFieldDateInput}
                           placeholder={viewData.currentDate}
                           defaultValue={viewData.currentDate}
                           onFocus={(e) => (e.currentTarget.type = "date")}
                    />
                    </div>
            </div>
            </div>
            <div className={classes.newBillBlock}>
                <NewBillDetails data={currentBill.Details} add={addDetail} del={deleteDetail}/>
            </div>
            <div className={classes.newBillBlock}>
                <div className={classes.newBillBlockReference}>
                    <div className={classes.newBillBlockItem}>
                        <div className={classes.newBillFieldSectionLabel}> Referencias</div>
                        <NewBillReferences setGlosa={setGlosa} setReason={setReason}/>
                    </div>
                    { (currentBill.Type==52) &&
                     <div className={classes.newBillBlockGuideReference}>
                        <div className={classes.newBillFieldSectionLabel}>Datos de envío</div>
                        <div className={classes.newBillFieldGuideContainer}>
                            <div className={classes.newBillFieldGuideLabel}>
                                <label className={classes.newBillFieldGuideLabel} htmlFor='ShippingAddress'>Dirección</label>
                                    <input type='text'
                                        id='ShippingAddress'
                                        className={classes.newBillFieldInput}
                                        placeholder='Ingrese Dirección'
                                        onChange={setShippingAddress}
                                    />
                            </div>
                        </div> 
                        <div className={classes.newBillFieldGuideContainer}> 
                            <div className={classes.newBillFieldGuideLabel}>
                                <label className={classes.newBillFieldGuideLabel} htmlFor='ShippingLocality'>Comuna</label>
                                    <input type='text'
                                        id='ShippingLocality'
                                        className={classes.newBillFieldInput}
                                        placeholder='Ingrese Comuna'
                                        onChange={setShippingLocality}
                                    />
                            </div>
                        </div> 
                        <div className={classes.newBillFieldLabel}>
                            <label className={classes.newBillFieldGuideLabel} htmlFor='AdditionalInformation'>Observación</label>
                                <input type='text'
                                    id='AdditionalInformation'
                                    className={classes.newBillFieldInput}
                                    placeholder='Indique más información'
                                    onChange={setAdditionalInformation}
                                />
                        </div>
                        </div>
                    }
                    </div>
                <div>
                <div className={classes.newBillFieldSectionLabel}>Totales</div>
                    <div>
                       <div className={classes.newBillFieldContainer} >
                            <div className={classes.newBillFieldLabel}>
                                <label htmlFor='net'>Neto:</label>
                            </div>
                            <div className={classes.newBillFieldDiv} >
                                <div type='text'
                                       id='net'
                                       className={classes.newBillFieldTotalData} >
                               {formatCurrency(totals.totalNeto)}
                                </div>
                            </div>
                        </div>
                         <div className={classes.newBillFieldContainer} >
                            <div className={classes.newBillFieldLabel}>
                                <label htmlFor='Exento'>Exento:</label>
                            </div>
                            <div className={classes.newBillFieldDiv} >
                                <div type='text'
                                       id='Exento'
                                       className={classes.newBillFieldTotalData} >
                                 {formatCurrency(totals.totalExento)}
                                </div>
                            </div>
                        </div>
                         <div className={classes.newBillFieldContainer} >
                            <div className={classes.newBillFieldLabel}>
                                <label htmlFor='iva'>I.V.A.:</label>
                            </div>
                            <div className={classes.newBillFieldDiv} >
                                <div type='text'
                                       id='iva'
                                       className={classes.newBillFieldTotalData}  >
                                 {formatCurrency(totals.totalIva)}
                                </div>
                            </div>
                        </div>
                         <div className={classes.newBillFieldContainer} >
                            <div className={classes.newBillFieldLabel}>
                                <label htmlFor='taxes'>
                                    Imptos/Retenciones
                                </label>
                            </div>
                            <div className={classes.newBillFieldDiv} >
                                <div
                                   type='text'
                                   id='taxes'
                                   className={classes.newBillFieldTotalData}  >
                                 {formatCurrency(totals.totalRetencion)}
                                </div>
                            </div>
                        </div>
                         <div className={classes.newBillFieldContainer} >
                            <div className={classes.newBillFieldLabel}>
                                <label htmlFor='totals'>Totales</label>
                            </div>
                            <div className={classes.newBillFieldDiv} >
                                <div
                                   type='text'
                                   id='totals'
                                   className={classes.newBillFieldTotalData} >
                                     {formatCurrency(totals.totalTotal)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             <div className={classes.newBillBlockButtons}>
                <button className="cancelButton" onClick={toPage}>Cancelar</button>
                <button className="emitirButton" onClick={emit}>Emitir</button>
            </div>
        </div>
    </div>
  )
}

export default NewBill
